// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3zjSQ","options":"AnswerScale_options__3Uuri","selected":"AnswerScale_selected__KPcj8"};